import * as React from 'react'

import { GroupPayrollView } from '../tabs/registry/views/payroll'
import { RouteComponentProps } from '@/app/navigation/withRouter'

interface RouteParams {
  companyId: string
}

export const DriverGroupTimesheetBonusAndRewardsPage: React.FC<
  RouteComponentProps<RouteParams>
> = ({ match }) => {
  const { companyId } = match.params
  

  return (
      <GroupPayrollView companyId={companyId} />
  )
}
